import React from 'react';
import UnknownDumbView from '../../../DeviationViews/Dumbo/Unknown';
import { Props } from '../MonoView';
import { useEditorContainerSize } from '@wix/da-editor-tiptap/pkg/components/Editor/Context';
import cn from 'classnames';
import { useFreeformSquareSizing } from '../helpers';

import s from './Unknown.scss';

const UnknownMonoView: React.FC<Props> = props => {
  const containerSize = useEditorContainerSize();
  const { deviation, extOptions, width: propsWidth } = props;
  const size = useFreeformSquareSizing(propsWidth, extOptions, containerSize);

  return (
    <div className={cn(s['root'], extOptions.smallMedia && s['small'])}>
      <UnknownDumbView
        width={size.width}
        height={size.height}
        deviation={deviation}
      />
    </div>
  );
};
UnknownMonoView.displayName = 'UnknownMonoView';

export default UnknownMonoView;
